import React, {Component} from 'react';
import './Account.css';
import profpic from '../../assets/img/dummyprofpic.png';
import SubmitAbstract from './SubmitAbstract'

import { useQuery } from '@apollo/client';
import { USER_PROFILE } from '../../queries';
import SubmitAbstractContainer from './SubmitAbstract';


const Account = () => {
    const { error, data } = useQuery(USER_PROFILE);

    if (error) return `Error! ${error.message}`;

    return (
        <AccountBoard profile={data?.profile}/ >
    );
}

class AccountBoard extends Component{
    competition() {
        return (
        <>
            <h1>Competition</h1>
            {this.competitions.map( (t,i) =>
            <div className="compebox" key={i}>
                <div>
                    <h3>{t.name}</h3>
                    <h4>{t.competition.name}</h4>
                    <h4>Deadline Abstrak : 1 Januari 2020</h4>

                    <div className="text-right">
                    <h5>Status Pembayaran: </h5>
                    {t.payment.status === "PAYING" ?
                    <>
                        <h5>Belum dibayar</h5>
                        <a
                        className="btn btn-primary shadow-sm"
                        target="_blank" rel="noopener"
                        href={t.competition.name === "Innovation Competition" ? "https://bit.ly/TeaserInnovationIMPULSE21" : "https://bit.ly/TeaserPaperIMPULSE21"}>
                        Guidebook
                        </a>
                        <a href={t.payment.url} className="text-right btn btn-primary m-2 shadow-sm">Klik untuk Membayar</a> 
                    </>:
                    t.payment.status === 'SUCCESS' ?
                    <>
                    <a
                        className="btn btn-primary shadow-sm"
                        target="_blank" rel="noopener"
                        href={t.competition.name === "Innovation Competition" ? "https://bit.ly/GuidebookInnovation" : "https://bit.ly/GuidebookPaper"}>
                        Guidebook
                    </a>
                        <h5>Pembayaran Berhasil</h5>
                        <SubmitAbstractContainer teamId={t.id} paperFilename={t.paperFilename} paperFileUrl={t.paperFileUrl}/>
                    </>:

                    t.payment.status === 'PENDING' ?
                        <>
                        
                        <h5>Mohon tunggu hingga diverifikasi oleh sistem</h5> 
                        <a
                        className="btn btn-primary shadow-sm"
                        target="_blank" rel="noopener"
                        href={t.competition.name === "Innovation Competition" ? "https://bit.ly/TeaserInnovationIMPULSE21" : "https://bit.ly/TeaserPaperIMPULSE21"}>
                        Guidebook
                        </a>
                        <a href={t.payment.url} className="text-right btn btn-primary m-2 shadow-sm">Klik untuk Membayar</a>
                        </>
                        :
                    <>
                    
                    <h5>Lakukan Pembayaran ulang atau hubungi instagram jika tidak bisa</h5>
                    <a
                        className="btn btn-primary shadow-sm"
                        target="_blank" rel="noopener"
                        href={t.competition.name === "Innovation Competition" ? "https://bit.ly/TeaserInnovationIMPULSE21" : "https://bit.ly/TeaserPaperIMPULSE21"}>
                        Guidebook
                        </a>
                    <a href={t.payment.url} className="text-right btn btn-primary m-2 shadow-sm">Klik untuk membayar lagi</a>
                    </>
                    }
                    </div>
                </div>
            </div>)}
        </>
        )
    }

    workshop() {
        const textWorkshop = "Anda sudah terverifikasi";
        return (
        <>
            <h1>Workshop</h1>
            
            {this.props.profile.WorkshopFirstToAccount.map( (t,i) =>
            <div className="compebox" key={i}>
                <h4 style={{wordBreak:"break-word", textAlign:"center"}}>Klik pada bagian pengumpulan bukti, lalu tunggu hingga diverifikasi oleh admin</h4>
                <div>
                    <a style ={{fontSize: "100%", textAlign:"center", display:"block"}} href = "https://bit.ly/FormBerkasWSImpulse"><u>Klik untuk mengumpulkan bukti</u></a>
                         
                    <h4 style ={{textAlign:"center"}}>{t.isWorkshopVerified ? 
                        textWorkshop : "Anda belum diverifikasi"}</h4>
                    {/*
                    {t.isWorkshopVerified ?
                        <>
                        <h3>Opening workshop</h3>
                        <h4>Monday, 4 January 2021<br/>
                        09.00-12.00<br/>
                        Participant may enter the meeting 20 minutes before the event<br/>
                        <br/>
                        <b>Zoom link:<br/></b>
                        <a href="https://us02web.zoom.us/j/82166801241?pwd=NVJURFBKN2pYQS9nZ3JLR3pGOXBMZz09" >
                            https://us02web.zoom.us/j/82166801241?pwd=NVJURFBKN2pYQS9nZ3JLR3pGOXBMZz09
                        </a><br/>
                        <br/>
                        <b>Meeting ID: 821 6680 1241<br/></b>
                        <b>Passcode: 941877<br/></b>
                        
                        For your username, please use the following format: [WP] – Your name<br/>
                        <b>For example: [WP] - Jameson</b>
                        </h4>
                        </>
                        :
                        <></>
                    }
                */}
                    {
                        
                        t.paymentStatus == "PENDING" ?
                            <div className="container text-center">
                            <h3 >Kumpulkan bukti pembayaran ke link berikut</h3>
                            <a href="https://forms.gle/2sBgmT6RG6phHM1P7"><u>Form Pembayaran</u></a><br/>
                            </div>
                        : t.paymentStatus == "SUCCESS" ?
                            <div className="container text-center">
                                <h3>Anda sudah sukses melakukan pembayaran</h3>
                            </div>
                        : <></>
                    }
                </div>
            </div>)}
        </>
        )
    }

    profile() {
        this.competitions = this.props.profile.teams.concat(this.props.profile.leads);
        return (
            <>
            <div className="col-md-3 data">
                <img src={profpic} alt="display" className="foto"/>
                <div className="underline"><p>{this.props.profile.username}</p></div>
                <div className="underline"><p>{this.props.profile.name}</p></div>
                <div className="underline"><p>{this.props.profile.schoolName}</p></div>
            </div>
            <div className="col-md-9 reminder">
                <h1>Daftar Event yang anda ikuti</h1>
                {this.competitions.length ? this.competition() : <div className="compebox"></div>}
                {this.props.profile.WorkshopFirstToAccount.length ? this.workshop() : <div className="compebox"></div>}
            </div>
            </>
        )
    }

    render() {
        return (
            <div>
                <div className="container1">
                    <div className="row m-0 p-0">
                        {this.props.profile ? this.profile() : <></>}
                    </div>
                </div>
            </div>


        )
    }
}

export default Account
